import { LegalEntitiesPageHeader } from './components/LegalEntitiesPageHeader';
import { LegalEntities } from './LegalEntities.main';

export { LegalEntities, LegalEntitiesPageHeader };
